import Vue from 'vue'
import { Loading } from 'element-ui'

export async function loadingData(fn) {
    let loading = Loading.service()
    try {
        await fn()
    }
    finally {
        loading.close()
    }
}

export const EventBus = new Vue()



// WEBPACK FOOTER //
// ./src/utils/index.js